import { render, staticRenderFns } from "./GridPatentes.vue?vue&type=template&id=78c99015&"
import script from "./GridPatentes.vue?vue&type=script&lang=ts&"
export * from "./GridPatentes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78c99015', component.options)
    } else {
      api.reload('78c99015', component.options)
    }
    module.hot.accept("./GridPatentes.vue?vue&type=template&id=78c99015&", function () {
      api.rerender('78c99015', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/GridPatentes.vue"
export default component.exports